import { useEffect, useState } from 'react';
// eslint-disable-next-line no-unused-vars
import { FaTimes } from 'react-icons/fa';
import { useBottomSheet } from '../contexts/BottomSheetContext';

const BottomSheet = () => {
  const { isOpen, content, title, height, headerColor, closeBottomSheet } = useBottomSheet();
  const [shouldRender, setShouldRender] = useState(false);
  const [isAnimating, setIsAnimating] = useState(false);

  useEffect(() => {
    if (isOpen) {
      setShouldRender(true);
      // 次のフレームでアニメーションを開始（初期位置を確保するため）
      setTimeout(() => {
        setIsAnimating(true);
      }, 10);
    } else {
      setIsAnimating(false);
    }
  }, [isOpen]);

  useEffect(() => {
    const handleEsc = (e) => {
      if (e.key === 'Escape' && isOpen) {
        closeBottomSheet();
      }
    };
    window.addEventListener('keydown', handleEsc);
    return () => window.removeEventListener('keydown', handleEsc);
  }, [isOpen, closeBottomSheet]);

  useEffect(() => {
    if (isOpen) {
      document.body.style.overflow = 'hidden';
    } else {
      document.body.style.overflow = 'unset';
    }
    return () => {
      document.body.style.overflow = 'unset';
    };
  }, [isOpen]);

  const handleTransitionEnd = () => {
    if (!isOpen) {
      setShouldRender(false);
    }
  };

  if (!shouldRender) return null;

  const heightClass = height === 'full' ? 'h-[90vh]' : height === 'medium' ? 'h-[60vh]' : 'h-auto max-h-[80vh]';
  
  const colorClasses = {
    green: {
      bg: 'bg-gradient-to-r from-green-600 to-blue-600',
      border: 'border-green-700',
      hover: 'hover:from-green-700 hover:to-blue-700'
    },
    orange: {
      bg: 'bg-gradient-to-r from-orange-600 to-red-600',
      border: 'border-orange-700',
      hover: 'hover:from-orange-700 hover:to-red-700'
    },
    blue: {
      bg: 'bg-gradient-to-r from-blue-600 to-purple-600',
      border: 'border-blue-700',
      hover: 'hover:from-blue-700 hover:to-purple-700'
    },
    red: {
      bg: 'bg-gradient-to-r from-red-600 to-pink-600',
      border: 'border-red-700',
      hover: 'hover:from-red-700 hover:to-pink-700'
    },
    yellow: {
      bg: 'bg-gradient-to-r from-orange-600 to-yellow-600',
      border: 'border-yellow-700',
      hover: 'hover:from-orange-700 hover:to-yellow-700'
    }
  };
  
  const colors = colorClasses[headerColor] || colorClasses.green;

  return (
    <div 
      className={`fixed inset-0 z-[9999] flex items-end justify-center transition-opacity duration-700 ${
        isAnimating ? 'opacity-100' : 'opacity-0 pointer-events-none'
      }`}
      onTransitionEnd={handleTransitionEnd}
      style={{ position: 'fixed', top: 0, left: 0, right: 0, bottom: 0 }}
    >
      <div
        className="absolute inset-0 bg-black bg-opacity-50 transition-opacity duration-700"
        onClick={closeBottomSheet}
      />

      <div
        className={`relative bg-white rounded-t-2xl shadow-2xl w-full ${heightClass} transform transition-all duration-700 ease-in-out ${
          isAnimating ? 'translate-y-0' : 'translate-y-full'
        }`}
      >
        <div className={`sticky top-0 z-10 flex items-center justify-between px-6 py-4 border-b ${colors.border} ${colors.bg} rounded-t-2xl`}>
          <h2 className="text-xl font-bold text-white">{title}</h2>
          <button
            onClick={closeBottomSheet}
            className={`p-2 text-white hover:text-white hover:opacity-80 ${colors.hover} rounded-full transition-colors`}
          >
            <FaTimes size={20} />
          </button>
        </div>

        <div className="overflow-y-auto px-6 py-4" style={{ maxHeight: 'calc(90vh - 80px)' }}>
          {content}
        </div>
      </div>
    </div>
  );
};

export default BottomSheet;
